"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideQuoteWithImage = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var react_1 = require("@emotion/react");

var SlideQuoteWithImage = function SlideQuoteWithImage(_ref) {
  var _ref$back = _ref.back,
      back = _ref$back === void 0 ? function () {} : _ref$back,
      _ref$next = _ref.next,
      next = _ref$next === void 0 ? function () {} : _ref$next,
      quote = _ref.quote,
      name = _ref.name,
      title = _ref.title,
      company = _ref.company,
      location = _ref.location,
      imageUrl = _ref.imageUrl,
      className = _ref.className,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var CarouselImage = styled_1.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\twidth: 100%;\n\t\t@media only screen and (min-width: ", ") {\n\t\t\tmargin-top: 90px;\n\t\t}\n\t\t@media only screen and (max-width: ", ") {\n\t\t\tmargin-top: 20px;\n\t\t}\n\t"])), theme.breakpoints.xl, theme.breakpoints.xl);
  var NextPrevButtons = (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tposition: absolute;\n\t\tright: 10%;\n\t\tbottom: -15px;\n\t"])));
  var AddMargin = (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tmargin-top: 50px;\n\t"])));
  var MainText = (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\twidth: 720px;\n\n\t\t@media only screen and (min-width: ", ") {\n\t\t\twidth: 760px;\n\t\t}\n\t"])), theme.breakpoints.xl);
  var LeftContent = (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\twidth: 100%;\n\t\th2 {\n\t\t\tmargin-top: 0px;\n\t\t}\n\n\t\t@media only screen and (min-width: ", ") {\n\t\t\twidth: 50%;\n\t\t}\n\t\t@media only screen and (max-width: ", ") {\n\t\t\tmargin-top: 30px;\n\t\t}\n\t"])), theme.breakpoints.lg, theme.breakpoints.lg);
  var BackButton = (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tmargin-right: 5px;\n\t"])));
  var SecondaryText = (0, react_1.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\tmargin-top: 20px;\n\t"])));
  var StartQuote = (0, styled_1.default)(frontend_assets_1.Icon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\tmargin-right: 12px;\n\n\t\t@media only screen and (max-width: ", ") {\n\t\t\tmargin-right: 5px;\n\t\t}\n\t"])), theme.breakpoints.lg);
  var EndQuote = (0, styled_1.default)(frontend_assets_1.Icon)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\ttransform: rotate(180deg) translateY(8px); // TODO: This rotate is temporary until we add a open-quote and close-quote icons.\n\t"])));
  return (0, jsx_runtime_1.jsxs)("div", {
    className: className,
    "data-testid": dataTestId,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "column",
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          direction: "column",
          style: (0, react_1.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t"]))),
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(CarouselImage, {
              src: imageUrl
            })
          }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "flex-end",
            css: NextPrevButtons,
            children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              css: BackButton,
              label: "",
              onClick: back,
              shape: "circle",
              leftIcon: "backward",
              foreground: "light",
              background: theme.colors.primary.darkGray
            }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              label: "",
              onClick: next,
              shape: "circle",
              leftIcon: "forward",
              foreground: "light",
              background: theme.colors.primary.darkGray
            })]
          })]
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          css: LeftContent,
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(StartQuote, {
              icon: "quote",
              size: "xs",
              color: theme.colors.primary.lightGray
            })
          }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
            children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              variant: "div",
              color: theme.colors.primary.darkGray,
              size: "xl",
              children: [quote, (0, jsx_runtime_1.jsx)(EndQuote, {
                icon: "quote",
                size: "xs",
                color: theme.colors.primary.lightGray
              })]
            }), (0, jsx_runtime_1.jsxs)("div", {
              css: SecondaryText,
              children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                variant: "div",
                size: "md",
                weight: "bold",
                children: [name, ", ", title]
              }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                variant: "div",
                size: "md",
                color: theme.colors.primary.gray,
                children: [company, ", ", location]
              })]
            })]
          })]
        })]
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        css: AddMargin,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          css: LeftContent,
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            css: MainText,
            children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                children: (0, jsx_runtime_1.jsx)(StartQuote, {
                  icon: "quote",
                  color: theme.colors.primary.lightGray
                })
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                  variant: "h2",
                  color: theme.colors.primary.darkGray,
                  children: [quote, (0, jsx_runtime_1.jsx)(EndQuote, {
                    icon: "quote",
                    color: theme.colors.primary.lightGray
                  })]
                }), (0, jsx_runtime_1.jsxs)("div", {
                  css: SecondaryText,
                  children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                    variant: "div",
                    size: "md",
                    weight: "bold",
                    children: [name, ", ", title]
                  }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                    variant: "div",
                    size: "md",
                    color: theme.colors.primary.gray,
                    children: [company, ", ", location]
                  })]
                })]
              })]
            })
          })
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          direction: "column",
          style: (0, react_1.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t"]))),
          children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "flex-end",
            children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              css: BackButton,
              label: "",
              onClick: back,
              shape: "circle",
              leftIcon: "backward",
              foreground: "light",
              background: theme.colors.primary.darkGray
            }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              label: "",
              onClick: next,
              shape: "circle",
              leftIcon: "forward",
              foreground: "light",
              background: theme.colors.primary.darkGray
            })]
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(CarouselImage, {
              src: imageUrl
            })
          })]
        })]
      })
    })]
  });
};

exports.SlideQuoteWithImage = SlideQuoteWithImage;